import { Engine1Proxy, RestApiProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
//Seteo de apiUrl
RestApiProxy.SetApiUrl();


export const GET_INITIAL_DATA_ATLAS_SUCCESS = 'GET_INITIAL_DATA_ATLAS_SUCCESS';
const ACCESO_DIRECTO_POP_UP_PROGRAMA = 'ACCESO_DIRECTO_POP_UP_PROGRAMA';

let _dispatch, _currentScope = null;

export function getInitialData(currentScope) {

    return (dispatch) => {
        _currentScope = currentScope;
        _dispatch = dispatch;

        var currentScopeRequest = {
            "UserId": _currentScope.UserId//,
            //"ProductCode": _currentScope.ProductCode
        }

        var params = {
            "USUARIO_ID": _currentScope.UserId
        };

        Engine1Proxy.AddDataSourcesRequests(params, 'GET_MENU_BY_USUARIO_ID', 'Get', 'Concierge', 'Seguridad', 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_PRODUCTO_USUARIO_LOGIN', 'Get', 'Concierge', 'Seguridad', 1, 'User');
        Engine1Proxy.AddDataSourcesRequests(currentScopeRequest, 'GET_USUARIO_INICIO', "Get", 'Concierge', 'Seguridad', "Product", 1);
        Engine1Proxy.Execute(_loadInitialStateData, null, null, "SEGURIDAD");

    }

}

export function accesoDirectoPopUpPrograma(defaultProducto) {
    LogHelper.In(accesoDirectoPopUpPrograma.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ACCESO_DIRECTO_POP_UP_PROGRAMA, defaultProducto: defaultProducto });
    }
}

///////////////////////////////

function _loadInitialStateData(data) {
    LogHelper.In(_loadInitialStateData.name, data);

    let result = {
        "GET_MENU_BY_USUARIO_ID": JSON.parse(data.GET_MENU_BY_USUARIO_ID).Recordset0.Rows,
        "GET_USUARIO_INICIO": JSON.parse(data.GET_USUARIO_INICIO).Recordset0.Rows,
        "GET_PRODUCTO_USUARIO_LOGIN": JSON.parse(data.GET_PRODUCTO_USUARIO_LOGIN).Recordset0.Rows
    }

    _dispatch({ type: GET_INITIAL_DATA_ATLAS_SUCCESS, result: result });

    LogHelper.Out(_loadInitialStateData.name, data);
}
